/**
 * A place for shared analytics schema definitions.
 */

import { EntityType } from "fond/types";

import { oneOf, string, z } from "../schema-util";

export const featureId = string().describe("The ID of the feature");
export const layerId = string().describe("The ID of the layer");
export const projectId = string().describe("The ID of the project");
export const entityId = string().describe("The ID of the entity");
export const entityType = oneOf(EntityType).describe("The type of the entity");
export const reportId = string().describe("The ID of the report");
export const noProps = z.null();
